export function fileTypeLabel(name: string, mimeType: string | null | undefined): string {
  const mime = String(mimeType || '').toLowerCase();
  const ext = (() => {
    const m = String(name || '').toLowerCase().match(/\.([a-z0-9]{1,8})$/);
    return m ? m[1] : '';
  })();

  if (mime === 'application/pdf' || ext === 'pdf') return 'PDF';
  if (mime.startsWith('image/') || ['png', 'jpg', 'jpeg', 'gif', 'webp', 'svg'].includes(ext)) return 'Image';

  if (
    mime === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
    mime === 'application/vnd.ms-excel' ||
    ['xlsx', 'xls', 'xlsm'].includes(ext)
  ) {
    return 'Excel';
  }
  if (mime === 'text/csv' || ext === 'csv') return 'CSV';

  if (
    mime === 'application/vnd.openxmlformats-officedocument.presentationml.presentation' ||
    mime === 'application/vnd.ms-powerpoint' ||
    ['pptx', 'ppt'].includes(ext)
  ) {
    return 'PowerPoint';
  }
  if (
    mime === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
    mime === 'application/msword' ||
    ['docx', 'doc'].includes(ext)
  ) {
    return 'Word';
  }

  if (mime === 'application/zip' || ['zip'].includes(ext)) return 'ZIP';

  return ext ? ext.toUpperCase() : mimeType || 'File';
}

export function canPreviewOnline(mimeType: string | null | undefined): boolean {
  const mime = String(mimeType || '').toLowerCase();
  return mime === 'application/pdf' || mime.startsWith('image/');
}

